module.exports = __webpack_public_path__ + "img/back_length_to_waist.6463c0b7.png";